import { render, staticRenderFns } from "./FaqExamples.vue?vue&type=template&id=fc526b44&scoped=true&"
import script from "./FaqExamples.vue?vue&type=script&lang=js&"
export * from "./FaqExamples.vue?vue&type=script&lang=js&"
import style0 from "./FaqExamples.vue?vue&type=style&index=0&id=fc526b44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc526b44",
  null
  
)

export default component.exports